export function mainMenus() {
    "use strict";

    return [
        {
            name: "Hours of Service",
            alias: "hos",
            icon: "local_shipping",
            show: false,
            conditions: ["hasProducts", "hasHosPermission", "hasEldFeatures"],
            subMenus: []
        },
        {
            name: "DVIR",
            alias: "dvir",
            icon: "dvr",
            show: false,
            conditions: ["hasProducts","hasDvirPermission", "hasDvirFeatures"],
            subMenus: []
        },
        {
            name: "State Mileage",
            alias: "ifta",
            icon: "local_gas_station",
            show: false,
            conditions: ["hasProducts", "hasIftaPermission", "hasIftaFeatures"],
            subMenus: []
        },
        {
            name: "Mobile Worker",
            alias: "mobile-worker",
            icon: "work",
            show: false,
            conditions: ["hasProducts", "hasMobileWorkerPermission", "mobileWorker"],
            subMenus: []
        },
        {
            name: "Settings",
            alias: "settings",
            icon: "settings",
            show: true,
            subMenus: []
        },
        {
            name: "Admin Tools",
            alias: "admin-tools",
            icon: "build",
            show: false,
            conditions: ["isUserRoleVTAdmin"],
            subMenus: []
        }
    ];
}
